import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DownloadIcon from "@mui/icons-material/Download";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { Cheques, ChequesResponse } from "../../models/chequeProsses.model";
import { useMutation } from "react-query";
import { ProssesCheque } from "../../services/chequeProsses.service";
import { ApiResultModel } from "../../models/common.model";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ButtonStatus } from "./ChequeProsses";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

let mainColor: any;
const ExcelUploader = ({
  inputRef,

  data,
  setButtonStatus,
  buttonStatus,
}: {
  inputRef: any;

  data: Cheques[];
  setButtonStatus: (state: ButtonStatus) => void;
  buttonStatus: ButtonStatus;
}) => {
  const jsonFile = useSelector((state: any) => state.style);

  const [dataResponse, setDataResponse] = useState<ChequesResponse[]>();

  const ProssesChequeMutate = useMutation(ProssesCheque, {
    onSuccess: (data: ApiResultModel<ChequesResponse[]>) => {
      if (data) {
        setDataResponse(data.data);
        setButtonStatus("showExportExcel");
        toast.success(`تعداد (${data.data.filter((i) => i.isExsit).length})
        ردیف پردازش شد و تعداد 
        (${data.data.filter((i) => !i.isExsit).length})
         ردیف پردازش نشد`);
      }
    },
    onError: () => {},
  });
  const handelProcess = () => {
    ProssesChequeMutate.mutate(data);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(dataResponse!);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Not_processed.xlsx`);
  };
  mainColor = jsonFile?.mainColor;
  return (
    <>
      <Grid container marginBottom={"50px"}>
        <Grid item xs={1} textAlign={"center"}>
          <Typography
            component={"p"}
            sx={{ cursor: "pointer" }}
            color={jsonFile?.mainColor}
            fontWeight={"bold"}
            fontSize={"1rem"}
            onClick={() => {
              if (inputRef.current) {
                inputRef.current.click();
              }
            }}
          >
            <AddCircleOutlineIcon fontSize="small" sx={{ marginLeft: "5px" }} />
            بارگذاری فایل
          </Typography>
        </Grid>
        <Grid
          item
          xs={1}
          textAlign={"center"}
          sx={{
            borderLeft:
              buttonStatus !== "other"
                ? "1px solid rgb(207, 216, 220)"
                : "none",
            borderRight: "1px solid rgb(207, 216, 220)",
          }}
        >
          <a href="files/Sample_file.xlsx" target="_blank" download>
            <Typography
              component={"p"}
              sx={{ cursor: "pointer" }}
              color={jsonFile?.mainColor}
              fontWeight={"bold"}
              fontSize={"1rem"}
            >
              <DownloadIcon fontSize="small" sx={{ marginLeft: "5px" }} />
              دانلود فایل نمونه
            </Typography>
          </a>
        </Grid>
        {buttonStatus === "showProcess" && (
          <Grid item xs={1} textAlign={"center"}>
            <Typography
              component={"p"}
              sx={{ cursor: "pointer" }}
              color={jsonFile?.mainColor}
              fontWeight={"bold"}
              fontSize={"1rem"}
              onClick={handelProcess}
            >
              <PublishedWithChangesIcon
                fontSize="small"
                sx={{ marginLeft: "5px" }}
              />
              پردازش
            </Typography>
          </Grid>
        )}
        {buttonStatus === "showExportExcel" && (
          <Grid item xs={1} textAlign={"center"}>
            <Typography
              component={"p"}
              sx={{ cursor: "pointer" }}
              color={jsonFile?.mainColor}
              fontWeight={"bold"}
              fontSize={"1rem"}
              onClick={exportToExcel}
            >
              <DownloadIcon fontSize="small" sx={{ marginLeft: "5px" }} />
              پردازش نشده ها
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default ExcelUploader;
